exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-SearchBox__input {\n  --clear-btn-top: -0.65rem; }\n", ""]);

// exports
